import React, {useState, useEffect, useRef} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import {Modal} from 'react-bootstrap';
import {toast} from 'react-toastify';
import {getObjectFromArrayOfObjects} from '../../../../_helpers/helperFunctions';
import SearchTable from '../../../primer/Search-Table';
import {
    fetchAccountingSettings,
    fetchUnregulatedDebts,
    postUnregulatedDebts
} from '../../../../_apis/api';
import {setTaxisScrapingState} from '../../../../_reducers/DataPanel/Accounting/accountingSlice';
import SendDebtsEmailModal from './Components/SendDebtsEmailModal';
import axios from "axios";
import {getCurrentUser} from "../../../../_helpers/commonFunctions";

const EXTENSION_STORE_URL = 'https://chromewebstore.google.com/detail/inimchhmmahoignojckagbdbjhigglce';

const DEFAULT_COMPANY_CREDENTIALS = {
    username: '',
    password: '',
};

const debtStatusOptions = [
    {value: 'ALL', label: 'Όλες οι Οφειλές'},
    {value: 'ACTIVE', label: 'Εκκρεμείς (Ανοιχτές)'},
    {value: 'OVERDUE', label: 'Με Ληξιπρόθεσμο Υπόλοιπο'},
    {value: 'PAID', label: 'Πλήρως Εξοφλημένες'}
];

const taxTypeOptions = [
    {value: 'ALL', label: 'Όλα τα Είδη Φόρου'},
    {value: 'ΦΠΑ', label: 'Φόρος Προστιθέμενης Αξίας (Φ.Π.Α.)'},
    {value: 'ΕΙΣΟΔ', label: 'Φόρος Εισοδήματος (Ν.Π. / Φ.Π.)'},
    {value: 'ΕΝΦΙΑ', label: 'Ε.Ν.Φ.Ι.Α.'},
    {value: 'ΠΑΡΑΚΡΑΤ', label: 'Παρακρατούμενοι Φόροι (ΦΜΥ, κ.λπ.)'},
    {value: 'ΕΠΙΤΗΔΕΥΜ', label: 'Τέλος Επιτηδεύματος'},
    {value: 'ΚΥΚΛΟΦΟΡ', label: 'Τέλη Κυκλοφορίας'},
    {value: 'ΠΡΟΣΤΙΜ', label: 'Πρόστιμα / Παραβάσεις'}
];

const searchDebtsFilters = {
    filters: [
        {
            name: 'status',
            label: 'Κατάσταση Οφειλής',
            type: 'dropdown',
            options: debtStatusOptions,
            mdWidth: 3
        },
        {
            name: 'taxType',
            label: 'Είδος Φόρου',
            type: 'dropdown',
            options: taxTypeOptions,
            mdWidth: 3
        },
        {name: 'initial_amount_from', label: 'Αρχικό Ποσό Από (€)', type: 'input', mdWidth: 3},
        {name: 'initial_amount_to', label: 'Αρχικό Ποσό Έως (€)', type: 'input', mdWidth: 3},
        {name: 'total_amount_from', label: 'Υπόλοιπο Από (€)', type: 'input', mdWidth: 3},
        {name: 'total_amount_to', label: 'Υπόλοιπο Έως (€)', type: 'input', mdWidth: 3}
    ]
};

const defaultDebtsColumns = [
    {
        name: 'Κατάσταση',
        field: 'status',
        width: '9%',
        editable: false,
        inputType: {
            type: 'text',
        }
    },
    {name: 'Είδος Φόρου', field: 'taxType', width: '16%', editable: false, inputType: {type: 'text'}},
    {name: 'Ταυτότητα Οφειλής', field: 'paymentCode', width: '14%', editable: false, inputType: {type: 'text'}},
    {name: 'Οικ. Έτος', field: 'taxYear', width: '5%', editable: false, inputType: {type: 'text'}},
    {name: 'Ημ/νία Βεβαίωσης', field: 'assessmentDate', width: '8%', editable: false, inputType: {type: 'text'}},
    {name: 'ΔΟΥ', field: 'doy', width: '9%', editable: false, inputType: {type: 'text'}},
    {
        name: 'Αρχικό Βεβαιωθέν',
        field: 'initialAmount',
        width: '9%',
        editable: false,
        inputType: {type: 'accounting', config: {suffix: '€'}}
    },
    {
        name: 'Εξοφληθέν',
        field: 'totalPaidAmount',
        width: '9%',
        editable: false,
        inputType: {type: 'accounting', config: {suffix: '€'}}
    },
    {
        name: 'Μη Ληξιπρόθεσμο',
        field: 'nonOverdueAmount',
        width: '8%',
        editable: false,
        inputType: {type: 'accounting', config: {suffix: '€'}}
    },
    {
        name: 'Ληξιπρόθεσμο',
        field: 'overdueAmount',
        width: '7%',
        editable: false,
        inputType: {type: 'accounting', config: {suffix: '€'}}
    },
    {
        name: 'Συνολικό Υπόλοιπο',
        field: 'totalAmount',
        width: '7%',
        editable: false,
        inputType: {type: 'accounting', config: {suffix: '€'}}
    }
];

const checkExtensionInstalled = (timeoutMs = 800) => {
    return new Promise((resolve) => {
        const handleMessage = (event) => {
            if (event.source === window && event.data?.type === 'TAXIS_EXTENSION_PONG') {
                window.removeEventListener('message', handleMessage);
                clearTimeout(timer);
                resolve(true);
            }
        };
        window.addEventListener('message', handleMessage);
        window.postMessage({type: 'PING_TAXIS_EXTENSION'}, '*');
        const timer = setTimeout(() => {
            window.removeEventListener('message', handleMessage);
            resolve(false);
        }, timeoutMs);
    });
};

const isChromiumBrowser = () => {
    const nav = window.navigator;
    if (nav.userAgentData && Array.isArray(nav.userAgentData.brands)) {
        return nav.userAgentData.brands.some((b) =>
            ['Chromium', 'Google Chrome', 'Microsoft Edge', 'Opera', 'Brave'].includes(b.brand)
        );
    }
    const ua = nav.userAgent;
    return /Chrome|Chromium|Edg|OPR/i.test(ua) && !(/Firefox|FxiOS|Safari/i.test(ua) && !/Chrome|Edg|OPR/i.test(ua));
};

const SearchAadeUnregulatedDebts = () => {
    const dispatch = useDispatch();
    const company = useSelector((state) => state.COMPANY_DATA.company);
    const companyDetails = useSelector((state) => state.COMPANY_DATA.companyDetails);
    const companyCredentials = useSelector((state) => state.ACCOUNTING_DATA.accountingCompanyCredentials) || DEFAULT_COMPANY_CREDENTIALS;
    const currentTableFilters = useSelector((state) => state.SEARCH_TABLE.filters['Unregulated Debts Search']) || {};
    const debtsList = useSelector((state) => state.ACCOUNTING_DATA.unregulatedDebts) || [];

    const [isScraping, setIsScraping] = useState(false);
    const [isExtensionInstalled, setIsExtensionInstalled] = useState(false);
    const [showExtensionModal, setShowExtensionModal] = useState(false);
    const [tableColumns, setTableColumns] = useState(defaultDebtsColumns.slice());
    const [showEmailModal, setShowEmailModal] = useState(false);

    const activeScrapeCompanyIdRef = useRef(null);
    const scrapeSafetyTimeoutRef = useRef(null);
    const scrapeDatesRef = useRef({date_from: '01/01/2026', date_to: '31/12/2026'});

    const resetScrapeState = () => {
        if (scrapeSafetyTimeoutRef.current) clearTimeout(scrapeSafetyTimeoutRef.current);
        activeScrapeCompanyIdRef.current = null;
        setIsScraping(false);
        dispatch(setTaxisScrapingState({active: false, message: ''}));
    };

    useEffect(() => {
        setTableColumns(defaultDebtsColumns.slice());
    }, []);

    useEffect(() => {
        if (!company?.id) return;
        dispatch(fetchAccountingSettings({company: company.id}));
    }, [company?.id, dispatch]);

    useEffect(() => {
        const checkExtension = (event) => {
            if (event.source !== window) return;
            if (event.data?.type === 'TAXIS_EXTENSION_READY' || event.data?.type === 'TAXIS_EXTENSION_PONG') {
                setIsExtensionInstalled(true);
            }
        };

        window.addEventListener('message', checkExtension);
        window.postMessage({type: 'PING_TAXIS_EXTENSION'}, '*');
        return () => window.removeEventListener('message', checkExtension);
    }, []);

    useEffect(() => {
        const handleExtensionMessages = (event) => {
            if (event.source !== window || !event.data) return;
            const {type, action, success, error, data} = event.data;
            if (type === 'TO_ERP_SCRAPE_DEBTS_RESPONSE') {
                if (activeScrapeCompanyIdRef.current && activeScrapeCompanyIdRef.current !== company?.id) {
                    resetScrapeState();
                    return;
                }

                if (success === false || error) {
                    resetScrapeState();
                    toast.error(error || 'Σφάλμα επικοινωνίας με το myAADE κατά την άντληση οφειλών.', {
                        autoClose: 10000,
                        pauseOnHover: true
                    });
                    return;
                }

                if (success && data) {
                    const debtsCount = data.debts ? data.debts.length : 0;
                    const targetCompanyId = company?.id;

                    dispatch(postUnregulatedDebts({company: targetCompanyId, debtsData: data}));

                    toast.info(`Αντλήθηκαν ${debtsCount} οφειλές. Έλεγχος πληρωμών...`, {autoClose: 3500});

                    (async () => {
                        let existingPaymentKeys = [];
                        let dynamicDateFrom = '01/01/2025';
                        let combinedDebtsInfo = [];

                        try {
                            const existingRes = await axios.post(
                                `${process.env.REACT_APP_API_URL2}/accounting/get-unregulated-debts`,
                                {company: targetCompanyId, status: 'ALL', export: true},
                                {headers: {'Content-Type': 'application/json'}}
                            );

                            const resData = existingRes.data?.data;
                            const allDbDebts = resData?.data || (Array.isArray(resData) ? resData : []);
                            const keysSet = new Set();
                            const assessmentTimestamps = [];

                            if (Array.isArray(allDbDebts)) {
                                allDbDebts.forEach((debt) => {
                                    (debt.payments || []).forEach((p) => {
                                        if (p.paymentCode) keysSet.add(String(p.paymentCode).trim());
                                        if (p.receiptNo) keysSet.add(String(p.receiptNo).trim());
                                        if (p.atb && p.xkLine) keysSet.add(`${String(p.atb).trim()}_${String(p.xkLine).trim()}`);
                                        if (p.approvalCode) keysSet.add(String(p.approvalCode).trim());
                                    });

                                    if (debt.assessmentDate && /^\d{2}\/\d{2}\/\d{4}$/.test(debt.assessmentDate)) {
                                        const [d, m, y] = debt.assessmentDate.split('/').map(Number);
                                        const ts = new Date(y, m - 1, d).getTime();
                                        if (!isNaN(ts)) assessmentTimestamps.push({ts, str: debt.assessmentDate});
                                    }

                                    const instAmounts = (debt.installments || []).map(i =>
                                        Number(Number(i.totalAmount || i.remainingAmount || 0).toFixed(2))
                                    );

                                    combinedDebtsInfo.push({
                                        assessmentDate: String(debt.assessmentDate || '').trim(),
                                        taxType: String(debt.taxType || '').trim(),
                                        taxYear: String(debt.taxYear || '').trim(),
                                        totalAmount: Number(debt.totalAmount || 0),
                                        initialAmount: Number(debt.initialAmount || 0),
                                        installmentAmounts: instAmounts
                                    });
                                });
                            }

                            existingPaymentKeys = Array.from(keysSet);

                            if (assessmentTimestamps.length > 0) {
                                assessmentTimestamps.sort((a, b) => a.ts - b.ts);
                                dynamicDateFrom = assessmentTimestamps[0].str;
                            }
                        } catch (err) {
                            console.warn('[DebtsScrape]: Δεν κατέστη δυνατή η ανάκτηση των υπαρχουσών οφειλών.', err);
                        }

                        setTimeout(() => {
                            const payloadPayments = {
                                companyId: targetCompanyId,
                                credentials: {
                                    username: companyCredentials.username,
                                    password: companyCredentials.password
                                },
                                companyAfm: company?.vatNumber?.trim(),
                                actionType: 'SCRAPE_PAYMENTS',
                                period: {
                                    dateFrom: dynamicDateFrom,
                                    dateTo: scrapeDatesRef.current.date_to || '31/12/2026'
                                },
                                existingPaymentKeys,
                                activeDebtsInfo: combinedDebtsInfo
                            };

                            dispatch(
                                setTaxisScrapingState({
                                    active: true,
                                    message: `Σε εξέλιξη άντληση αποδεικτικών πληρωμής myAADE (από ${dynamicDateFrom})...`
                                })
                            );

                            window.postMessage({type: 'FROM_ERP_SCRAPE_PAYMENTS', payload: payloadPayments}, '*');
                        }, 500);
                    })();
                }
                return;
            }

            if (type === 'TO_ERP_SCRAPE_PAYMENTS_RESPONSE') {
                if (activeScrapeCompanyIdRef.current && activeScrapeCompanyIdRef.current !== company?.id) {
                    resetScrapeState();
                    return;
                }

                if (success === false || error) {
                    resetScrapeState();
                    toast.warning(error || 'Ολοκληρώθηκαν οι οφειλές, αλλά απέτυχε η άντληση πληρωμών.', {
                        autoClose: 8000,
                        pauseOnHover: true
                    });
                    dispatch(fetchUnregulatedDebts({company: company?.id, ...currentTableFilters}));
                    return;
                }

                if (success && data) {
                    const receiptsCount = data.receipts ? data.receipts.length : 0;
                    toast.info(`Συσχέτιση ${receiptsCount} αποδεικτικών πληρωμών myAADE...`, {autoClose: 3500});

                    const targetCompanyId = company?.id;
                    dispatch(
                        postUnregulatedDebts(
                            {company: targetCompanyId, receiptsData: data, actionType: 'SCRAPE_PAYMENTS'},
                            setIsScraping,
                            () => {
                                resetScrapeState();
                                toast.success(`Ολοκληρώθηκε ο πλήρης συγχρονισμός οφειλών & πληρωμών myAADE!`);
                                dispatch(fetchUnregulatedDebts({company: targetCompanyId, ...currentTableFilters}));
                            }
                        )
                    );
                }
                return;
            }

            if (action === 'AUTOFILL_FAILED' || action === 'AUTOFILL_FAILED_AND_CLOSE') {
                resetScrapeState();
                toast.error(error || 'Η διαδικασία στο myAADE απέτυχε.', {
                    autoClose: 10000,
                    pauseOnHover: true
                });
            }

            if (type === 'TO_ERP_TAXIS_WINDOW_CLOSED') {
                resetScrapeState();
                toast.info('Η διαδικασία myAADE ακυρώθηκε (το παράθυρο έκλεισε).', {
                    autoClose: 4000
                });
            }
        };

        window.addEventListener('message', handleExtensionMessages);
        return () => window.removeEventListener('message', handleExtensionMessages);
    }, [company?.id, currentTableFilters, dispatch, companyCredentials]);

    const handleScrapeDebts = async (filterParams = {}) => {
        if (!isChromiumBrowser()) {
            toast.warning('Απαιτείται περιηγητής Chromium (Chrome, Edge, Brave, Opera).', {
                autoClose: 5000,
                pauseOnHover: true
            });
            return;
        }

        if (scrapeSafetyTimeoutRef.current) clearTimeout(scrapeSafetyTimeoutRef.current);
        scrapeSafetyTimeoutRef.current = setTimeout(() => {
            if (isScraping) {
                resetScrapeState();
                toast.warn('Η διαδικασία myAADE ξεπέρασε το όριο χρόνου.');
            }
        }, 65000);

        let installed = isExtensionInstalled;
        if (!installed) {
            installed = await checkExtensionInstalled(800);
            if (installed) {
                setIsExtensionInstalled(true);
            }
        }

        if (!installed) {
            setShowExtensionModal(true);
            return;
        }

        if (!companyCredentials?.username || !companyCredentials?.password) {
            toast.error('Δεν έχουν οριστεί εταιρικοί κωδικοί myAADE στις ρυθμίσεις.');
            return;
        }

        const resolvedAfm = company?.vatNumber?.trim();
        if (!resolvedAfm) {
            toast.error('Δεν βρέθηκε έγκυρο ΑΦΜ επιχείρησης.');
            return;
        }

        try {
            scrapeDatesRef.current = {
                date_from: filterParams.date_from || '01/01/2026',
                date_to: filterParams.date_to || '31/12/2026'
            };

            const payload = {
                credentials: {
                    username: companyCredentials.username,
                    password: companyCredentials.password
                },
                companyAfm: resolvedAfm,
                actionType: 'SCRAPE_UNREGULATED_DEBTS'
            };

            activeScrapeCompanyIdRef.current = company.id;
            setIsScraping(true);

            dispatch(
                setTaxisScrapingState({
                    active: true,
                    message: 'Σε εξέλιξη σύνδεση και αυτόματη άντληση οφειλών εκτός ρύθμισης από το myAADE...'
                })
            );

            toast.info('Έναρξη άντλησης οφειλών από το myAADE...', {autoClose: 3000});
            window.postMessage({type: 'FROM_ERP_SCRAPE_DEBTS', payload}, '*');
        } catch (err) {
            console.error('Scrape Debts Error:', err);
            resetScrapeState();
            toast.error('Σφάλμα κατά την έναρξη της άντλησης.');
        }
    };

    const handleColumnShowHide = (field) => {
        let tempTc = tableColumns.slice();
        let object = getObjectFromArrayOfObjects(tempTc, field, 'field');
        const index = tempTc.findIndex((item) => field === item.field);
        if (object.length > 0) {
            tempTc[index].hiddenColumn = !object['0'].hiddenColumn;
            setTableColumns(tempTc);
        }
    };

    const handleSendEmail = async (emailPayload) => {
        try {
            const res = await axios.post(
                `${process.env.REACT_APP_API_URL2}/accounting/send-debts-email`,
                {
                    company: company?.id,
                    ...emailPayload
                },
                {headers: {'Content-Type': 'application/json'}}
            );

            if (res.data?.status === '200') {
                toast.success(`Το email στάλθηκε επιτυχώς σε: ${emailPayload.emails.join(', ')}`);

                if (res.data.debtsEmailConf) {
                    const localUser = getCurrentUser();
                    if (localUser) {
                        localUser.debtsEmailConf = res.data.debtsEmailConf;
                        localStorage.setItem('user', JSON.stringify(localUser));
                    }
                }
            } else {
                toast.error(res.data?.message || 'Σφάλμα κατά την αποστολή του email.');
            }
        } catch (err) {
            console.error('Send Debts Email Error:', err);
            toast.error(err?.response?.data?.message || 'Σφάλμα επικοινωνίας με τον διακομιστή.');
        }
    };

    return (
        <div>
            <SearchTable
                tableName="Unregulated Debts Search"
                key="Unregulated Debts Search"
                allowSorting={true}
                hideYearFilter={false}
                allowOtherYears={true}
                allowPagination={true}
                allowToggleColumns={true}
                toggleColumns={handleColumnShowHide}
                allowPrintResults={true}
                exportFileName="Οφειλές Εκτός Ρύθμισης myAADE"
                dataEndpoint="/accounting/get-unregulated-debts"
                columns={tableColumns}
                data={[]}
                filtersConfig={searchDebtsFilters}
                onSendEmailClick={() => setShowEmailModal(true)}
                onScrapeClick={handleScrapeDebts}
                isScraping={isScraping}
                scrapeButtonTitle="Άντληση Οφειλών myAADE"
            />

            <SendDebtsEmailModal
                show={showEmailModal}
                onHide={() => setShowEmailModal(false)}
                company={companyDetails}
                debts={debtsList}
                onSendEmail={handleSendEmail}
            />

            <Modal
                show={showExtensionModal}
                onHide={() => setShowExtensionModal(false)}
                dialogClassName="modal65PercentWidth"
                centered
            >
                <Modal.Header closeButton className="border-bottom-0 pb-2">
                    <Modal.Title className="d-flex align-items-center">
                        <div>
                            <h5 className="mb-0 font-weight-bold" style={{fontSize: '1.05rem', color: '#111827'}}>
                                Απαιτείται το Πρόσθετο Primer ERP - Taxis Bridge
                            </h5>
                            <span className="text-muted" style={{fontSize: '0.75rem'}}>
                                Αυτοματοποίηση διασύνδεσης με το myAADE
                            </span>
                        </div>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className="pt-2 pb-3 px-4">
                    <p className="text-muted mb-3" style={{fontSize: '0.85rem', lineHeight: '1.45'}}>
                        Για την ασφαλή άντληση των οφειλών και πληρωμών από το myAADE, απαιτείται η εγκατάσταση του
                        επίσημου bridge στον περιηγητή σας.
                    </p>
                    <div className="p-3 mb-3 rounded"
                         style={{backgroundColor: '#f8fafc', border: '1px solid #e2e8f0'}}>
                        <div className="font-weight-bold mb-3 text-dark" style={{fontSize: '0.8rem'}}>
                            Οδηγίες Εγκατάστασης:
                        </div>
                        <div className="d-flex flex-column" style={{gap: '10px'}}>
                            <div className="d-flex align-items-start">
                                    <span
                                        className="d-inline-flex align-items-center justify-content-center rounded-circle mr-2 text-white bg-primary flex-shrink-0"
                                        style={{
                                            width: '20px',
                                            height: '20px',
                                            fontSize: '0.7rem',
                                            marginTop: '1px'
                                        }}>1</span>
                                <span className="text-dark" style={{fontSize: '0.8rem', lineHeight: '1.45'}}>
                                    Πατήστε <strong>«Μετάβαση στο Chrome Web Store»</strong>.
                                </span>
                            </div>
                            <div className="d-flex align-items-start">
                                    <span
                                        className="d-inline-flex align-items-center justify-content-center rounded-circle mr-2 text-white bg-primary flex-shrink-0"
                                        style={{
                                            width: '20px',
                                            height: '20px',
                                            fontSize: '0.7rem',
                                            marginTop: '1px'
                                        }}>2</span>
                                <span className="text-dark" style={{fontSize: '0.8rem', lineHeight: '1.45'}}>
                                    Ενεργοποιήστε την επιλογή <strong>«Να επιτρέπεται σε ανώνυμη περιήγηση» (Allow in incognito)</strong> στις ρυθμίσεις του προσθέτου.
                                </span>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer className="border-top-0 pt-0 px-4 pb-3">
                    <a
                        href={EXTENSION_STORE_URL}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="btn btn-primary btn-sm px-3 d-inline-flex align-items-center"
                        onClick={() => setShowExtensionModal(false)}
                    >
                        <i className="fa-brands fa-chrome mr-2"></i>
                        Μετάβαση στο Chrome Web Store
                    </a>
                </Modal.Footer>
            </Modal>
        </div>
    );
};

export default SearchAadeUnregulatedDebts;